module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img26.3f903903.jpg";